<template>
  <div class="xin">
    <!-- 面包屑 -->

    <!-- tab 切换  -->
    <div class="switch">
      <el-tabs>
        <!-- 异常账号  -->
        <el-tab-pane label="异常账号">
          <span slot="label">{{ $t("logs.abnuser") }}</span>

          <div class="switch1">
            <div class="main">
              <!-- 导出异常账号  -->

              <el-button
                @click="daochu1"
                :disabled="$root.jurisdiction.only_query == 0"
                style="margin-right:8px"
                >{{ $t("logs.expabe") }}</el-button
              >
              <el-select
                v-model="salt_minion_ip"
                @change="change1"
                size="smail"
                v-if="this.has_minion == 1"
              >
                <el-option
                  v-for="item in minion_host"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="main1">
              <el-alert
                :title="$t('logs.shuo1')"
                type="warning"
                show-icon
                :closable="false"
              ></el-alert>
            </div>
            <div class="table">
              <el-table
                :data="fileList"
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :row-class-name="tableRowClassName"
                v-loading="loading"
              >
                <!-- 弱口令账号 -->

                <el-table-column
                  prop="RECSEQ"
                  :label="$t('table1.order')"
                  width="100"
                >
                </el-table-column>
                <!-- 异常账号 -->

                <el-table-column prop="ABUSE_EMAIL" :label="$t('logs.abnuser')">
                </el-table-column>
                <el-table-column prop="ADDTIME" :label="$t('logs.addt')">
                </el-table-column>
                <el-table-column prop="address" :label="$t('table.operate')">
                  <template slot-scope="scope">
                    <!-- 删除-->

                    <el-button
                      @click="handleClick1(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("logs.removeabus") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <!-- 弱口令账号 -->
        <el-tab-pane label="弱口令账号">
          <span slot="label"> {{ $t("logs.weakp") }}</span>
          <div class="switch1">
            <div class="main">
              <el-button
                @click="qing1"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.claerwu") }}</el-button
              >
              <el-button
                @click="daochu2"
                style="margin-right:8px"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.claerwu1") }}</el-button
              >
              <el-select
                v-model="salt_minion_ip01"
                @change="change2"
                size="smail"
                v-if="this.has_minion == 1"
              >
                <el-option
                  v-for="item in minion_host"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="main1">
              <el-alert
                :title="$t('logs.shuo2')"
                type="warning"
                show-icon
                :closable="false"
              ></el-alert>
            </div>
            <div class="table">
              <el-table
                :data="fileList1"
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('table1.order')"
                  width="100"
                >
                </el-table-column>
                <el-table-column
                  prop="WEAKPASS_EMAIL"
                  :label="$t('logs.weakp')"
                >
                </el-table-column>
                <el-table-column
                  prop="WEAKPASS_TYPE"
                  :label="$t('logs.weakp1')"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <!-- 内容滥发账号  -->
        <el-tab-pane label="内容滥发账号">
          <span slot="label"> {{ $t("logs.contab") }}</span>
          <div class="switch1">
            <div class="main">
              <el-button
                @click="qing2"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.clearcon") }}</el-button
              >
              <el-button
                @click="daochu3"
                style="margin-right:8px"
                :disabled="$root.jurisdiction.only_query == 0"
                >{{ $t("logs.clearcon1") }}</el-button
              >
              <el-select
                v-model="salt_minion_ip02"
                @change="change3"
                size="smail"
                v-if="this.has_minion == 1"
              >
                <el-option
                  v-for="item in minion_host"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="main1">
              <el-alert
                :title="$t('logs.shuo3')"
                type="warning"
                show-icon
                :closable="false"
              ></el-alert>
            </div>
            <div class="table">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList2"
                :row-class-name="tableRowClassName"
              >
                <!-- 弱口令账号 -->

                <el-table-column
                  prop="RECSEQ"
                  :label="$t('table1.order')"
                  width="100"
                >
                </el-table-column>
                <!-- 异常账号 -->

                <el-table-column
                  prop="CONTABUSE_EMAIL"
                  :label="$t('logs.contab')"
                >
                </el-table-column>
                <el-table-column prop="ADDTIME" :label="$t('logs.addt')">
                </el-table-column>
                <el-table-column prop="address" :label="$t('table.operate')">
                  <template slot-scope="scope">
                    <!-- 删除-->

                    <el-button
                      @click="handleClick3(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("table1.delete") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      salt_minion_ip: "127.0.0.1",
      salt_minion_ip01: "127.0.0.1",
      salt_minion_ip02: "127.0.0.1",
      minion_host: [],
      col: {
        a: "",
      },
      fileList: [],
      fileList1: [],
      fileList2: [],
      has_minion: "",
      loading:false,
    };
  },
  mounted() {
    this.getFileList();
    this.getFileList2();
    this.getFileList3();
  },
  methods: {
    // 各行变色
    tableRowClassName({ rowIndex }) {
      // console.log(row,rowIndex)
      if (rowIndex % 2 == 1) {
        return "warning-row";
        // console.log(2222)
      } else if (rowIndex % 2 !== 1) {
        return "success-row";
      }
      return "";
    },
    // 下拉框点击选中
    change1(a) {
      console.log(a);
      this.salt_minion_ip = a;
     this. getFileList() 
    },
    // 下拉框点击选中
    change2(a) {
      console.log(a);
      this.salt_minion_ip01 = a;
     this. getFileList2() 
    
    },
    // 下拉框点击选中
    change3(a) {
      console.log(a);
      this.salt_minion_ip02 = a;
     this. getFileList3() 
    
    },
    // 数据加载1
    getFileList() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/mon.cgi", {
          params: {
            __mode: "list_abuse_email",
            sid: sid,

            salt_minion_ip: this.salt_minion_ip,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);
            this.loading = false;

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
            
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            alert("请重新登录");
            this.$router.push({
              name: "login",
            });
          } else {
            if (res.data.ret.HAS_MINION ) {
              this.minion_host = res.data.ret.q_minion_host;
              this.has_minion = 1;
             
            }
            this.fileList = res.data.ret.datalist;
           
          }
        });
    },
    // 删除1
    handleClick1(index, scope) {
      // console.log(index, scope);
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let abuse_email = scope.ABUSE_EMAIL;
          let salt_minion_ip = this.salt_minion_ip;

          this.$axios
            .get("/api/adm/cgi/mon.cgi", {
              params: {
                __mode: "del_abuse_email",
                sid: sid,
                abuse_email: abuse_email,
                salt_minion_ip: salt_minion_ip,
              },
            })
            .then((res) => {
              console.log(res);

              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
               
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.loading = false;
                this.getFileList();
                this.$message({
                  type: "success",
                  message: `${this.$t("anti_gs1_tan.del1")}`,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // 数据加载2
    getFileList2() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/mon.cgi", {
          params: {
            __mode: "list_weakpass_email",
            sid: sid,
            salt_minion_ip: this.salt_minion_ip01,

            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
            // this.getFileList()
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            // alert("请重新登录");
            this.$router.push({
              name: "login",
            });
          } else {
            if (res.data.ret.HAS_MINION ) {
              this.minion_host = res.data.ret.q_minion_host;
              // this.salt_minion_ip01 = res.data.ret.q_minion_host[0].label;
            }
            this.fileList1 = res.data.ret.datalist;

            // console.log(this.page)
          }
        });
    },
    // 数据加载3
    getFileList3() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      // console.log(this)
      // 获取表单数据,搜索条件

      // console.log(col, '5555')

      this.$axios
        .get("/api/adm/cgi/mon.cgi", {
          params: {
            __mode: "list_cont_abuse",
            sid: sid,
            salt_minion_ip: this.salt_minion_ip02,
            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
            // this.getFileList()
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            // alert("请重新登录");
            this.$router.push({
              name: "login",
            });
          } else {
            if (res.data.ret.HAS_MINION) {
              this.minion_host = res.data.ret.q_minion_host;
              // this.salt_minion_ip02 = res.data.ret.q_minion_host[0].label;
            }
            this.fileList2 = res.data.ret.datalist;

            // console.log(this.page)
          }
        });
    },
    // 删除2
    handleClick3(index, scope) {
      // console.log(index, scope);
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let cont_abuse = scope.CONTABUSE_EMAIL;
          let salt_minion_ip = this.salt_minion_ip02;

          this.$axios
            .get("/api/adm/cgi/mon.cgi", {
              params: {
                sid: sid,
                __mode: "del_cont_abuse",
                cont_abuse: cont_abuse,
                salt_minion_ip: salt_minion_ip,
              },
            })
            .then((res) => {
              console.log(res);

              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
                // this.getFileList();
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.loading = false;
                this.getFileList3();
                this.$message({
                  type: "success",
                  message: `${this.$t("anti_gs1_tan.del1")}`,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // 异常账号导出
    daochu1() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);

      let __mode = "download_abuse_email";
      let salt_minion_ip = this.salt_minion_ip;

      // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
      window.open(
        `/api/adm/cgi/mon.cgi?__mode=${__mode}&sid=${sid}&salt_minion_ip=${salt_minion_ip}`
      );
    },
    // 弱口令导出
    daochu2() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);
      let salt_minion_ip = this.salt_minion_ip01;
      let __mode = "download_weakpass_email";

      // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
      window.open(
        `/api/adm/cgi/mon.cgi?__mode=${__mode}&sid=${sid}&salt_minion_ip=${salt_minion_ip}`
      );
    },
    // 内容滥发导出
    daochu3() {
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);
      let salt_minion_ip = this.salt_minion_ip02;

      let __mode = "download_cont_abuse";

      // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
      window.open(
        `/api/adm/cgi/mon.cgi?__mode=${__mode}&sid=${sid}&salt_contabuse_ip=${salt_minion_ip}`
      );
    },
    // 清空
    qing1() {
      // console.log(index, scope);
      this.$confirm(`${this.$t("logs.qing_a")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let salt_minion_ip = this.salt_minion_ip01;

          this.$axios
            .get("/api/adm/cgi/mon.cgi", {
              params: {
                sid: sid,
                __mode: "clear_weakpass_email",

                salt_minion_ip: salt_minion_ip,
              },
            })
            .then((res) => {
              console.log(res);

              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
                // this.getFileList();
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.loading = false;
                this.getFileList2();
                this.$message({
                  type: "success",
                  message: `${this.$t("logs.qing_a1")}`,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("logs.qing_a")}`,
          });
        });
    },
    // 清空
    qing2() {
      // console.log(index, scope);
      this.$confirm(`${this.$t("logs.qing_a")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let salt_minion_ip = this.salt_minion_ip02;

          this.$axios
            .get("/api/adm/cgi/mon.cgi", {
              params: {
                sid: sid,
                __mode: "clear_cont_abuse",

                salt_minion_ip: salt_minion_ip,
              },
            })
            .then((res) => {
              console.log(res);

              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
                // this.getFileList();
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.loading = false;
                this.getFileList3();
                this.$message({
                  type: "success",
                  message: `${this.$t("logs.qing_a1")}`,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("logs.qing_a2")}`,
          });
        });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";

.main {
  border: 2px solid #d2d7e6;
  background: #ffffff;
  padding: 6px 0;
  margin-bottom: 10px;

  .el-button {
    margin-left: 10px;
  }

  .el-alert {
    margin-left: 0;
  }

  // input 框高度
  /deep/ .el-input__inner {
    height: 32px;
    padding: 0 6px;
  }
}

.main1 {
  display: flex;
  margin: 0 14px 10px 14px;
  // margin-bottom: 10px;
}
/deep/ .el-table{
  height: calc( 100vh - 280px);
}
</style>
